import { useTranslation } from 'react-i18next';
import { StarIcon } from '../../icons/StarIcon';
import classes from './Banner.module.scss';
import { QuickchatAiIcon } from '@/Domain/components/icons/uickchatAi.icon';

export const Banner = () => {
  const { t } = useTranslation('banner');

  return (
    <div className="relative px-16 py-12 flex flex-col justify-center gap-24 bg-slate-50">
      <QuickchatAiIcon className="scale-125 " />

      <div>
        <h1 className="text-2xl font-medium tracking-tighter mb-2">{t('title')}</h1>
        <p className="text-gray-500">{t('description')}</p>
      </div>

      <div className={`relative p-8 flex flex-col gap-8 rounded ${classes.cardGradient}`}>
        <div className={`${classes.backgroundGradient} absolute`} />

        <div className="flex">
          {Array.from({ length: 5 }).map((_, index) => (
            <StarIcon key={index} />
          ))}
        </div>
        <p>{t('quote')}</p>
        <div className="flex gap-2">
          <div className="flex items-center gap-6">
            <div className="rounded-full p-1">
              <img
                src="https://static.quickchat.ai/static/assets/avatar-polly.png"
                style={{ maxWidth: '50px', borderRadius: '50%' }}
                alt="Polly Barnfield"
              />
            </div>
            <div className="flex flex-col">
              <h2 className="font-medium">Polly Barnfield</h2>
              <p className="font-medium text-gray-600">CEO, Maybe Tech</p>
            </div>
          </div>
          <div className="border-l border-gray-300 mx-6" />
          <img
            src="https://static.quickchat.ai/static/assets/maybe-logo.png"
            alt="Mayby Logo"
            className="object-contain max-w-24"
          />
        </div>
      </div>
    </div>
  );
};
